// src/components/BlogList.tsx
import React from 'react';
import { BlogPost } from '../types/blog';
import BlogCard from './BlogCard';

interface BlogListProps {
  posts: BlogPost[];
  onPostClick: (post: BlogPost) => void;
  className?: string;
}

const BlogList: React.FC<BlogListProps> = ({ 
  posts, 
  onPostClick, 
  className = '' 
}) => {
  return (
    <div className={`blog-list ${className}`}>
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {posts.map(post => (
          <BlogCard 
            key={post.id}
            post={post}
            onClick={onPostClick}
          />
        ))}
      </div>
    </div>
  );
};

export default BlogList;